import '@aws-amplify/ui-react/styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './MainApp.css';
import React, { useState, useEffect } from 'react';
import fullLogo from '../SE_Logo_tagline.svg';

import { Authenticator, Image } from '@aws-amplify/ui-react';

import { Amplify, I18n } from "aws-amplify";
import { Link, Outlet, useLocation } from "react-router-dom";

import Sidebar from './sidebar.js';
import { SEC_ApiCall, getProfileImageUrlWithSchoolFallback } from './func.js';
import LoadingComp from './common/loading.js';
import { ApiError } from './common/apiError.js';
import VersionUpdateUi from './VersionUpdateUi';

import { ToastContainer } from "react-toastify";
import { ImLeaf } from "react-icons/im";

import appConfig from '../config';
import amplifyAuthConfig from '../amplifyAuthConfig';

import { clientVersion } from '../config.js';



export const userAppData = [];

Amplify.configure(amplifyAuthConfig);

// Override Amplify Authenticator default MFA wording.
I18n.putVocabularies({
  en: {
    'Confirm TOTP Code': 'Enter your MFA code',
  },
});

function getUserAppData() {
  // id token
  for (let key in sessionStorage) {
    let n = key.search("idToken");
    if (n !== -1) {
      let tokenKey = key
      let token = sessionStorage.getItem(tokenKey);
      userAppData['idToken'] = token;
    }
  }
  // access token
  for (let accessKey in sessionStorage) {
    let a = accessKey.search("accessToken");
    if (a !== -1) {
      let accessTokenKey = accessKey
      let accessToken = sessionStorage.getItem(accessTokenKey);
      userAppData['accessToken'] = accessToken;
    }
  }
  // email 
  for (let emailKey in sessionStorage) {
    let x = emailKey.search("userData");
    if (x !== -1) {
      let emailDataKey = emailKey
      let emailData = sessionStorage.getItem(emailDataKey);
      let emailObj = parseSessionUserData(emailData);
      let emailUserAttributes = Array.isArray(emailObj['UserAttributes']) ? emailObj['UserAttributes'] : [];

      for (let emailItem in emailUserAttributes) {
        let emailAttributeItem = emailUserAttributes[emailItem]?.['Name'];
        if (emailAttributeItem === 'email') {
          let email = emailUserAttributes[emailItem]['Value'];
          userAppData['email'] = email;
        }

      }
    }
  }
  // school code 
  for (let scKey in sessionStorage) {
    let x = scKey.search("userData");
    if (x !== -1) {
      let scDataKey = scKey
      let scData = sessionStorage.getItem(scDataKey);
      let scObj = parseSessionUserData(scData);
      let scUserAttributes = Array.isArray(scObj['UserAttributes']) ? scObj['UserAttributes'] : [];

      for (let scItem in scUserAttributes) {
        let scAttributeItem = scUserAttributes[scItem]?.['Name'];
        if (scAttributeItem === 'custom:schoolCode') {
          let schoolCode = scUserAttributes[scItem]['Value'];
          userAppData['schoolCode'] = schoolCode;
        }
      }
    }
  }
  // display name
  for (let nameKey in sessionStorage) {
    let y = nameKey.search("userData");
    if (y !== -1) {
      let nameDataKey = nameKey
      let nameData = sessionStorage.getItem(nameDataKey);
      let nameObj = parseSessionUserData(nameData);
      let nameUserAttributes = Array.isArray(nameObj['UserAttributes']) ? nameObj['UserAttributes'] : [];
      for (let nameItem in nameUserAttributes) {
        let nameAttributeItem = nameUserAttributes[nameItem]?.['Name'];
        if (nameAttributeItem === 'name') {
          let name = nameUserAttributes[nameItem]['Value'];
          userAppData['displayName'] = name;
        }

      }
    }
  }
}

/** Return a safe Cognito session record when cached browser data is incomplete. */
function parseSessionUserData(rawData) {
  try {
    const parsedData = JSON.parse(rawData);
    return isRecord(parsedData) ? parsedData : {};
  } catch (error) {
    console.warn('Ignoring malformed cached Cognito user data', error);
    return {};
  }
}

/** Identify JSON records without accepting null or arrays as permission maps. */
function isRecord(value) {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

/** Decode legacy JSON and low-level DynamoDB values at the section boundary. */
function decodeSection(value, depth = 0) {
  if (depth > 30) throw new Error('Bootstrap data is nested too deeply');
  if (typeof value === 'string') return decodeSection(JSON.parse(value), depth + 1);
  const decoded = decodeAttribute(value, depth);
  return typeof decoded === 'string' ? decodeSection(decoded, depth + 1) : decoded;
}

/** Unwrap typed attributes without interpreting ordinary nested strings as JSON. */
function decodeAttribute(value, depth = 0) {
  if (depth > 30) throw new Error('Bootstrap data is nested too deeply');
  if (Array.isArray(value)) return value.map(item => decodeAttribute(item, depth + 1));
  if (!isRecord(value)) return value;
  const keys = Object.keys(value);
  if (keys.length === 1) {
    if ('M' in value) {
      if (!isRecord(value.M)) throw new Error('Invalid DynamoDB map');
      return Object.fromEntries(Object.entries(value.M).map(([key, item]) => [key, decodeAttribute(item, depth + 1)]));
    }
    if ('L' in value) {
      if (!Array.isArray(value.L)) throw new Error('Invalid DynamoDB list');
      return decodeAttribute(value.L, depth + 1);
    }
    if ('S' in value) return value.S;
    if ('N' in value) return Number(value.N);
    if ('BOOL' in value) {
      if (typeof value.BOOL !== 'boolean') throw new Error('Invalid DynamoDB boolean');
      return value.BOOL;
    }
    if ('NULL' in value) return null;
  }
  return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, decodeAttribute(item, depth + 1)]));
}

/** An optional malformed section never interrupts the other bootstrap sections. */
function parseRecord(rawData) {
  try {
    const value = decodeSection(rawData);
    return isRecord(value) ? value : {};
  } catch {
    return {};
  }
}

/** Validate nested grants; invalid flags must not become truthy UI permissions. */
function validatePermissionFields(value) {
  if (Array.isArray(value)) {
    if (value.some(item => item == null)) throw new Error('Invalid permission entry');
    value.forEach(validatePermissionFields);
  } else if (isRecord(value)) {
    Object.entries(value).forEach(([key, item]) => {
      if (key !== 'formsAdmin'
        && (/^(can|allow|restrict)[A-Z]/.test(key) || /Admin$|Allowed$/.test(key))
        && typeof item !== 'boolean') {
        throw new Error('Invalid permission flag');
      }
      if (['classes'].includes(key) && (!Array.isArray(item) || item.some(entry => typeof entry !== 'string'))) {
        throw new Error('Invalid permission list');
      }
      if (['id', 'groupId', 'roomId', 'groupName', 'name', 'guid'].includes(key) && typeof item !== 'string') {
        throw new Error('Invalid permission identifier');
      }
      if (key === 'notifications' && (!isRecord(item) || Object.values(item).some(flag => typeof flag !== 'boolean'))) {
        throw new Error('Invalid notification flags');
      }
      validatePermissionFields(item);
    });
  }
}

/** Fail closed for each module while supporting numeric legacy permission strings. */
function parseRequestModuleData(rawData, payloadName) {
  try {
    const value = parseRecord(rawData);
    if (value.perms !== 1 && value.perms !== '1') return { perms: 0 };
    validatePermissionFields(value);
    if (payloadName === 'sysManagerData' && Object.entries(value).some(([key, item]) => key !== 'perms' && typeof item !== 'boolean')) {
      throw new Error('Invalid System Manager flag');
    }
    const recordLists = ['roomAccess', 'groupAccess', 'groups', 'access', 'memberships', 'activeStepRecords', 'tools', 'availableTools'];
    const stringLists = ['allowedTools', 'formsAdmin', 'activeSteps', 'approvedDomains'];
    if (payloadName === 'formsData') stringLists.push('forms');
    for (const key of [...recordLists, ...stringLists]) {
      if (!(key in value)) continue;
      if (!Array.isArray(value[key]) || value[key].some(item => recordLists.includes(key) ? !isRecord(item) : typeof item !== 'string')) {
        throw new Error('Invalid permission list');
      }
    }
    return { ...value, perms: 1 };
  } catch {
    console.warn(`Ignoring malformed ${payloadName} permissions`);
    return { perms: 0 };
  }
}

/** Keep stable Forms collections for dashboard and module consumers. */
function parseFormsData(rawData) {
  const value = parseRequestModuleData(rawData, 'formsData');
  const formsAdmin = value.formsAdmin || [];
  return { ...value, canCreateForms: value.canCreateForms === true,
    forms: [...new Set([...(value.forms || []), ...formsAdmin])], formsAdmin,
    activeSteps: value.activeSteps || [], activeStepRecords: value.activeStepRecords || [] };
}

/** Preserve the supported System Manager flag alias. */
function parseSysManagerData(rawData) {
  const value = parseRequestModuleData(rawData, 'sysManagerData');
  return { ...value, performanceManagementAdmin: value.performanceManagementAdmin === true || value.PerformanceManagementAdmin === true };
}

/** Only pass records with the expected display fields to dashboard consumers. */
function parseDisplayRecords(rawData, requiredFields, optionalFields = []) {
  try {
    const value = decodeSection(rawData);
    return Array.isArray(value) ? value.filter(item => isRecord(item)
      && requiredFields.every(key => typeof item[key] === 'string')
      && optionalFields.every(key => item[key] == null || typeof item[key] === 'string')) : [];
  } catch {
    return [];
  }
}

/** Guarantee metadata arrays and discard malformed room/group records. */
function parseBookingsMetadata(rawData) {
  const value = parseRecord(rawData);
  return {
    groups: parseDisplayRecords(value.groups, ['groupId', 'name'], ['type']),
    subGroups: parseDisplayRecords(value.subGroups, ['groupId', 'name']),
    rooms: parseDisplayRecords(value.rooms, ['roomId', 'groupId', 'name']),
  };
}

/** Legacy inventory/maintenance roles retain only their supported numeric levels. */
function parseLegacyRole(value) {
  return [1, 2, 3, 4, '1', '2', '3', '4'].includes(value) ? Number(value) : 0;
}

/** Keep a bookmarked denied module from mounting with unusable permissions. */
function canOpenModule(pathname) {
  const module = pathname.toLowerCase().split('/')[2];
  const permissionKeys = {
    itsupport: 'itRequestsData', repro: 'reproRequestsData', reprorequests: 'reproRequestsData',
    bookings: 'bookingsData', bookingsts: 'bookingsData', oncall: 'onCall',
    alert: 'alertData', sysmanager: 'sysManager', 'performance-management': 'performanceManagement',
    tools: 'toolsData', forms: 'formsData', rotas: 'rotasData',
  };
  if (module === 'seinvnt') return parseLegacyRole(userAppData.invUser) > 0;
  if (module === 'maintenance') return parseLegacyRole(userAppData.maintenanceUser) > 0;
  const permissionKey = permissionKeys[module];
  return !permissionKey || userAppData[permissionKey]?.perms === 1;
}

function getPageTitle(pathname) {
  const cleanPathname = String(pathname || '').toLowerCase();
  const moduleTitleMap = [
    { path: '/app/itsupport', title: 'IT' },
    { path: '/app/repro', title: 'Reprographics' },
    { path: '/app/reprorequests', title: 'Reprographics' },
    { path: '/app/seinvnt', title: 'SE Inventory' },
    { path: '/app/bookings', title: 'Bookings' },
    { path: '/app/bookingsts', title: 'Bookings' },
    { path: '/app/maintenance', title: 'Maintenance' },
    { path: '/app/oncall', title: 'OnCall' },
    { path: '/app/alert', title: 'Alert' },
    { path: '/app/performance-management', title: 'Performance Management' },
    { path: '/app/tools', title: 'Tools' },
    { path: '/app/sysmanager/tools', title: 'System Manager - Tools' },
    { path: '/app/sysmanager/general-settings', title: 'System Manager - General Settings' },
    { path: '/app/sysmanager/groups', title: 'System Manager - Permission Groups' },
    { path: '/app/forms', title: 'Forms' },
    { path: '/app/sysmanager/forms', title: 'System Manager - Forms' },
    { path: '/app/sysmanager/staff', title: 'System Manager - Staff' },
    { path: '/app/sysmanager/contacts', title: 'System Manager - Contacts' },
    { path: '/app/sysmanager/reprographics', title: 'System Manager - Reprographics' },
    { path: '/app/sysmanager/oncall', title: 'System Manager - OnCall' },
    { path: '/app/sysmanager/learners', title: 'System Manager - Learners' },
    { path: '/app/sysmanager', title: 'System Manager' },
    { path: '/app/support', title: 'Support' },
    { path: '/app/appsupport', title: 'Support' },
    { path: '/app/profile', title: 'Profile' },
  ];

  const matchingModule = moduleTitleMap.find((item) => cleanPathname.startsWith(item.path));
  if (matchingModule) {
    return `School Engine - ${matchingModule.title}`;
  }

  return 'School Engine';
}


function MainApp() {
  const location = useLocation();
  const [desktopView, setDesktopViewState] = useState(true);  // used by sidebar to decide what size the icons are as mobile view icons are smaller
  const [fullSidebar, setFullSidebarState] = useState(true); // used to trigger the movement between full and minimised sidebar, if true sidebar is full
  const [data, setDataState] = useState(null);
  const [isLoaded, setIsLoadedState] = useState(false);
  const [apiError, setApiErrorState] = useState(false);
  const [apiErrorText, setApiErrorTextState] = useState(null);
  const [updateRequired, setUpdateRequired] = useState(false);

  async function apiCall() {
    if (updateRequired) {
      return;
    }
    setIsLoadedState(false);
    var url = 'perms/';
    var params = {};
    try {
      const response = await SEC_ApiCall(url, params, setApiErrorState);
      const responseData = isRecord(response) ? response : {};

      // Check version mismatch once, then stop further permission calls.
      const apiVersion = (typeof responseData.version === 'string' ? responseData.version : '').trim();
      const uiVersion = String(clientVersion || appConfig['APP_VERSION_NUMBER'] || '').trim();
      if (apiVersion && uiVersion && apiVersion !== uiVersion) {

        console.log("Version mismatch - refreshing to update app");
        setUpdateRequired(true);
        setIsLoadedState(true);
        return;
        /*
        if ('caches' in window) {
          caches.keys().then(names => {
            for (let name of names) caches.delete(name);
          }).then(() => window.location.reload());
        } else {
          window.location.reload(true); // Legacy fallback
        }*/

      } else {
        userAppData['displayName'] = typeof responseData['displayName'] === 'string' ? responseData['displayName'] : '';
        userAppData['itRequestsData'] = parseRequestModuleData(responseData['itRequestsData'], 'itRequestsData');
        userAppData['reproRequestsData'] = parseRequestModuleData(responseData['reproRequestsData'], 'reproRequestsData');
        userAppData['invUser'] = parseLegacyRole(responseData['invUser']);
        userAppData['bookingsData'] = parseRequestModuleData(responseData['bookingsData'], 'bookingsData');
        userAppData['alertData'] = parseRequestModuleData(responseData['alertData'], 'alertData');
        userAppData['alert'] = { activeAlerts: parseDisplayRecords(
          parseRecord(responseData.alert).activeAlerts, [],
          ['title', 'subtitle', 'bgColour', 'textColour', 'alertUrl', 'alertId']
        ) };
        userAppData['bookingsMetadata'] = parseBookingsMetadata(responseData.bookingsMetadata);
        userAppData['maintenanceUser'] = parseLegacyRole(responseData['maintenanceUser']);
        userAppData['onCall'] = parseRequestModuleData(responseData['onCallData'], 'onCallData');
        userAppData['rotasData'] = parseRequestModuleData(responseData['rotasData'], 'rotasData');
        userAppData['sysManager'] = parseSysManagerData(responseData['sysManagerData']);
        userAppData['performanceManagement'] = parseRequestModuleData(responseData['performanceManagement'], 'performanceManagement');
        userAppData['toolsData'] = parseRequestModuleData(responseData['toolsData'], 'toolsData');
        userAppData['formsData'] = parseFormsData(responseData['formsData']);
        userAppData['cogId'] = typeof responseData['cogId'] === 'string' ? responseData['cogId'] : '';
        userAppData['profileImageId'] = typeof responseData.profileImageId === 'string' ? responseData.profileImageId : '';
        userAppData['profileImageUrl'] = getProfileImageUrlWithSchoolFallback(
          typeof responseData.profileImageUrl === 'string' ? responseData.profileImageUrl : '',
          userAppData['schoolCode']
        );
        userAppData['schoolName'] = typeof responseData['schoolName'] === 'string' ? responseData['schoolName'] : '';
        // Optional links cannot block application startup, including malformed legacy JSON.
        userAppData.dashboardLinks = [];
        userAppData.dashboardLinksError = responseData.dashboardLinksError === true;
        try {
          const links = decodeSection(responseData.dashboardLinks ?? []);
          if (!Array.isArray(links) || links.some(link => !link ||
            ['text', 'link', 'image'].some(field => typeof link[field] !== 'string'))) {
            throw new Error('Invalid dashboard links');
          }
          if (!userAppData.dashboardLinksError) userAppData.dashboardLinks = links;
        } catch {
          userAppData.dashboardLinksError = true;
        }
        userAppData['personalExtLinks'] = parseDisplayRecords(responseData.personalExtLinks, ['name', 'url']);
        userAppData['dashboardRotas'] = parseDisplayRecords(responseData.dashboardRotas, ['masterRotaId', 'rotaName']);
        setIsLoadedState(true);
        setDataState(response);
      }


    } catch (e) {
      setApiErrorState(true);
      setIsLoadedState(true);
      setApiErrorTextState(e);
      console.log(e);
    }
  }

  useEffect(() => {
    let viewportwidth = window.innerWidth;

    if (viewportwidth <= 700) {
      setDesktopViewState(false);
      setFullSidebarState(false);
    }
    apiCall();
    localStorage.clear();
    getUserAppData();
  }, []);

  useEffect(() => {
    document.title = getPageTitle(location.pathname);
  }, [location.pathname]);

  if (!isLoaded) {
    return (
      <LoadingComp />
    )
  } else if (apiError) {
    return (
      <ApiError />
    )
  } else if (updateRequired) {
    return (
      <VersionUpdateUi />
    )
  } else if (isLoaded && !apiError) {

    return (
      <div className="App">
        <ToastContainer />
        <Sidebar
          fullSidebarValue={fullSidebar}
          setFullSidebarState={setFullSidebarState}
          desktopView={desktopView}
        />

        <div className={fullSidebar ? 'moduleDiv-full' : 'moduleDiv-min'}>
          {canOpenModule(location.pathname) ? <Outlet /> : (
            <p role="status">This module is unavailable. Choose another module from the sidebar.</p>
          )}

        </div>
      </div>
    );
  }
};


function Header() {
  return (
    <div className='loginPageHeaderContainer'>
      <div className="loginPageRenewableBanner" role="status" aria-live="polite">
        <span className="loginPageRenewableBannerText">All our services and systems are powered by 100% renewable energy</span>
        <ImLeaf className="loginPageRenewableBannerIcon" aria-hidden="true" />
      </div>
      <div className='loginPageLogoDiv'>
        <a href="/" aria-label="Go to homepage">
          <Image
            alt="logo"
            src={fullLogo}
            width={'80%'}
            padding={20}
          />
        </a>
      </div>
    </div>
  );
}

function Footer() {
  return (
    <div className='loginPageFooterTextDiv'>
      <div className="loginPageFooterLinks">
        <Link className="loginPageForgotPasswordLink" to="/forgot-password">Forgot password?</Link>
        <span className="loginPageFooterLinkSeparator">|</span>
        <Link className="loginPageForgotPasswordLink" to="/privacy-policy">Privacy Policy</Link>
      </div>
      <p className='loginPageFooterText'>App Version: {appConfig['APP_VERSION_NUMBER']}</p>
      <p className='loginPageFooterText'>&copy; 2026 School Engine Ltd.</p>
      <p className='loginPageFooterText'>Registered in England and Wales. Company No. 17465505.</p>
    </div>
  );
}





/**
 * Wraps the app in the Amplify Authenticator UI for modern authentication flows.
 * @returns {JSX.Element} Authenticated application shell.
 */
export default function MainAppWithAuth() {
  return (
    <Authenticator
      components={{
        SignIn: {
          Header: Header,
          Footer: Footer,
        },
      }}
    >
      {() => <MainApp />}
    </Authenticator>
  );
}
